import React from 'react';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { avatarSrc } from '../../lib/avatar';

const initials = (n) => (n || '?').split(' ').filter(Boolean).slice(0, 2).map((x) => x[0]).join('').toUpperCase();

export const ChatAvatar = ({ name, url, className = 'h-9 w-9', testId }) => (
  <Avatar className={`${className} shrink-0`} data-testid={testId}>
    <AvatarImage src={avatarSrc(url)} className="object-cover" />
    <AvatarFallback className="bg-[#2D3E6F]/10 text-[#2D3E6F] text-xs font-semibold">{initials(name)}</AvatarFallback>
  </Avatar>
);
